/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import * as actionsParameter from './../parameter/actions';
import { CategoryActionTypes } from './types';
import { StoreState } from '../../createStore';
import httpsAdapter from '../../../adapters/https/https-adapter';

const erroMessage = "Ops! ocorreu um erro no servidor";

export function* findCategorys({}: ActionType<
  typeof actions.findCategoryRequest
>) {
  try {
    const { data } = yield call(
          [httpsAdapter, httpsAdapter.request],
          {
              isEncrypt: false,
              method: 'GET',
              path: '/api/category/categories',
          }
      );
    yield put(actions.findCategorySuccess(data.data));
  } catch (err) {
    yield put(actions.findCategoryFailure());
    if (err.response.status >= 500 && err.response.status <=599) {
      yield put(actionsParameter.setMessageToast({
        type: 'error', message: erroMessage
      }))
    }
  }
}

export function* searchComponents({payload: { categoryId }}: ActionType<typeof actions.searchComponents>) {
    try {
      const { category: { components } }: StoreState = yield select();

    if ((components.data[categoryId] || []).length > 0) {
        yield put(actions.searchComponentsAlreadyExist(categoryId));
        return;
    }

    const queryParameter = categoryId && categoryId.length > 0 ? `&category_id=${categoryId}&type=category` :  '';

    const { data } = yield call(
        [httpsAdapter, httpsAdapter.request],
        {
            isEncrypt: false,
            method: 'GET',
            path: `/api/components/banners?channel=web${queryParameter}`,
        }
    );

    yield put(actions.searchComponentsResponse(categoryId, data.data || []))
    } catch (err) {
      yield put(actions.searchComponentsResponse(categoryId || '', []));
    }
}

export default all([
  takeLatest(CategoryActionTypes.LOAD_REQUEST, findCategorys),
  takeLatest(CategoryActionTypes.SEARCH_COMPONENTS, searchComponents),
]);
